import { Select as AntSelect, Checkbox, Col, Form, Row, Spin, Tag } from "antd";
import { useController } from "react-hook-form";
import "./Select.scss";
import Empty from "../Empty/Empty";

function Select({
  onSearch,
  options,
  fetching,
  mode = null,
  // hook form specific
  onChange: customOnChange = null,
  name,
  control,
  defaultValue,
  filterOption = false,
  rules = {},
  label,
  readOnly,
  useDefaultTheme = true,
  is_checkbox = false,
  checkBoxValue = false,
  setCheckBox = {},
  ...props
}) {
  const {
    field: { ref, value, onBlur, onChange },
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
    rules,
  });
  const errorText = error?.message;
  const status = errorText ? "error" : "";
  console.log(options, "optionsoptions");
  return (
    <>
      <div className="rfhSelect">
        <Form.Item
          label={label}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          help={errorText}
          validateStatus={status}
        >
          <Row gutter={8} align="middle">
            {is_checkbox && (
              <Col>
                <Checkbox
                  onChange={(e) => {
                    setCheckBox(e.target.checked);
                  }}
                  value={checkBoxValue}
                />
              </Col>
            )}
            {(!is_checkbox || checkBoxValue) && (
              <Col flex="auto">
                <AntSelect
                  ref={ref}
                  value={value || null}
                  onBlur={onBlur}
                  onChange={(e, value) => {
                    if (value?.type) {
                      e.type = value?.type;
                    }
                    if (customOnChange) {
                      customOnChange(e, onChange);
                    } else {
                      onChange(e);
                    }
                  }}
                  mode={mode}
                  labelInValue
                  onSearch={onSearch}
                  filterOption={filterOption}
                  notFoundContent={
                    fetching ? (
                      <div className="flex justify-center py-5">
                        <Spin size="small" />
                      </div>
                    ) : (
                      <div className="flex justify-center">
                        <Empty
                          useDefaultTheme={false}
                          description={"No Options Available"}
                          className="flex flex-col items-center py-4"
                        />
                      </div>
                    )
                  }
                  options={options}
                  status={status}
                  {...props}
                  disabled={readOnly}
                  style={{ width: "100%" }}
                />
              </Col>
            )}
          </Row>
        </Form.Item>
      </div>
    </>
  );
}

export default Select;
